import { Flex, Image, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onGridItemClick: (id: ID, title: string) => void;
  serviceList: ServiceListItem[];
}

const ServicesGrid: FC<Props> = ({ onGridItemClick, serviceList }) => {
  const { t } = useTranslation();
  const textShadow = '0px 4px 11px rgba(0, 0, 0, 0.3)';

  return (
    <>
      <GridHeading>{t('servicesTitle')}</GridHeading>
      <Flex w="100%" flexWrap="wrap" justifyContent="space-between">
        {serviceList.map((service, index) => (
          <AppCard
            overflow="hidden"
            onClick={() => onGridItemClick(service.id, service.title)}
            h="230px"
            cursor="pointer"
            w="calc(100% / 3 - 10px)"
            p="15px"
            bgColor={service.backgroundColor ?? ''}
            key={index}
            mb={index < serviceList.length - 3 ? '16px' : '0'}
            position="relative"
          >
            <Image
              position="absolute"
              src={service.image}
              right="0"
              top="0"
              w="230px"
              h="230px"
            />
            <Flex
              h="100%"
              zIndex={5}
              position="relative"
              flexDir="column"
              justifyContent="flex-end"
            >
              <Text
                textShadow={textShadow}
                color={Color.OnPrimary}
                fontWeight={700}
                fontSize="22px"
                mb="5px"
              >
                {service.title}
              </Text>
              <Text
                textShadow={textShadow}
                color={Color.OnPrimary}
                fontWeight={700}
                fontSize={FontSize.sm}
              >
                {service.subtitle1}
                <br />
                {service.subtitle2}
              </Text>
            </Flex>
          </AppCard>
        ))}
      </Flex>
    </>
  );
};

export default ServicesGrid;
